import {useApiRequest} from './hook';
import {getSpecialityListEndpoint} from '@integraciones_doc24/wehealthy-api/root/speciality/getList';
import {UserEditionData} from '@integraciones_doc24/wehealthy-api/types/user';
import {getSubscribablePlanListEndpoint} from '@integraciones_doc24/wehealthy-api/root/plan/getSubscribableList';
import {createFastRegistrationDynamicLinkEndpoint} from '@integraciones_doc24/wehealthy-api/root/user/fastRegistration/dynamicLink';

export const useGetSpecialityListRequest = () => {
  const request = useApiRequest(getSpecialityListEndpoint);

  return async (mode: 'instantVideo' | 'videoAppointment' | 'deferredChat') => {
    const response = await request({query: {mode}});
    return response.data;
  };
};

export const useGetPlansRequest = () => {
  const request = useApiRequest(getSubscribablePlanListEndpoint);
  return async () => {
    const response = await request({});
    return response.data;
  };
};
export const useCreateRegistrationLinkRequest = () => {
  const request = useApiRequest(createFastRegistrationDynamicLinkEndpoint);
  return async (userData: UserEditionData, destination?: string) => {
    const response = await request({
      body: {
        ...userData,
        applicationId: 'wehealthy',
        destination,
      },
    });
    return response.data;
  };
};
